module.exports = __webpack_public_path__ + "img/dash-warehouse1-img.78f50862.svg";